class NiuNiuCartExtras extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.submit.bind(this));
    this.addEventListener('change', event => {
      if (event.target.matches('[data-protection]')) this.protect(event.target);
      if (event.target.matches('[data-recommendation] select')) this.price(event.target);
    });
    this.querySelectorAll('[data-recommendation] select').forEach(select => this.price(select));
  }

  price(select) {
    const option = select.selectedOptions[0];
    const money = cents => new Intl.NumberFormat(document.documentElement.lang, {
      style: 'currency', currency: Shopify.currency.active
    }).format(cents / 100);
    const target = select.closest('form').querySelector('[data-recommend-price]');
    const image = select.closest('form').querySelector('img');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
    }
    target.replaceChildren();
    const price = Number(option.dataset.price);
    const reference = Number(option.dataset.reference);
    if (reference > price) {
      const old = document.createElement('s');
      old.textContent = money(reference);
      target.append(old, ' ');
    }
    target.append(money(price));
    if (reference > price) {
      const saving = document.createElement('span');
      saving.className = 'nn-save';
      saving.textContent = window.nnUi.save.replace('[amount]', money(reference - price));
      target.append(' ', saving);
    }
  }

  async request(url, body) {
    const drawer = this.closest('cart-drawer');
    if (drawer.classList.contains('nn-cart-busy')) return null;
    drawer.classList.add('nn-cart-busy');
    drawer.querySelectorAll('.nn-cart-scroll, .drawer__footer').forEach(element => { element.inert = true; });
    this.querySelector('[data-cart-message]').textContent = '';
    try {
      const response = await fetch(url, {
        ...fetchConfig(),
        body: JSON.stringify({ ...body, sections: drawer.getSectionsToRender().map(s => s.id), sections_url: window.location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.errors || result.status) throw new Error(result.description || window.nnUi.cart_error);
      if (!result.sections?.['cart-drawer']) throw new Error(window.nnUi.cart_retry);
      drawer.renderContents(result);
      return result;
    } catch (error) {
      drawer.querySelector('[data-cart-message]').textContent = error.message || window.nnUi.cart_retry;
      return null;
    } finally {
      drawer.classList.remove('nn-cart-busy');
      drawer.querySelectorAll('.nn-cart-scroll, .drawer__footer').forEach(element => { element.inert = false; });
    }
  }

  async submit(event) {
    event.preventDefault();
    const form = event.target;
    if (form.matches('[data-recommendation]')) {
      await this.request(routes.cart_add_url, { items: [{ id: form.elements.id.value, quantity: 1 }] });
    } else if (form.matches('[data-discount]')) {
      const code = form.elements.discount.value.trim();
      if (!code) return;
      const result = await this.request(routes.cart_update_url, { discount: code });
      if (!result) return;
      const applied = result.discount_codes?.some(d => d.code.toLowerCase() === code.toLowerCase() && d.applicable);
      document.querySelector('cart-drawer [data-cart-message]').textContent = applied
        ? window.nnUi.discount_applied : window.nnUi.discount_invalid;
      document.querySelector('cart-drawer #nn-discount')?.focus();
    }
  }

  async protect(input) {
    const selected = input.checked;
    const result = await this.request(routes.cart_update_url, { updates: { [input.value]: selected ? 1 : 0 } });
    if (!result && input.isConnected) input.checked = !selected;
    document.querySelector('cart-drawer [data-protection]')?.focus();
  }
}
if (!customElements.get('nn-cart-extras')) customElements.define('nn-cart-extras', NiuNiuCartExtras);
